import { COUNTERS_ROUTING } from "./counters-routing";
import { ENGINE_TRENDING_ROUTING } from "./engine-trending-routing";
import { PERFORMANCE_ROUTING } from "./performance-routing";
import { RISK_ROUTING } from "./risk-routing";
import { RouteParameters } from "./route-parameters";
import { WEIGHT_AND_BALANCE_ROUTING } from "./weight-and-balance-routing";

const OPERATIONS_ROUTING = {
  COUNTERS: COUNTERS_ROUTING,
  ENGINE_TRENDING: ENGINE_TRENDING_ROUTING,
  PERFORMANCE: PERFORMANCE_ROUTING,
  RISK: RISK_ROUTING,
  ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations`,
  WEIGHT_AND_BALANCE: WEIGHT_AND_BALANCE_ROUTING,
} as const;

export { OPERATIONS_ROUTING };
